import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Text } from '@notino/react-styleguide';

import { loyaltyMessages } from '../../messages';

interface ActiveProps {
  points: number;
  productQuantity: number;
}

export const Active = ({ points, productQuantity }: ActiveProps) => {
  const { formatNumber } = useIntl();
  return (
    <Text typography="labelSmall400" color="text.secondary">
      <FormattedMessage
        {...loyaltyMessages.pointsToEarnText}
        values={{
          b: (chunks) => (
            <Text typography="labelSmall" color="text.primary">
              {chunks}
            </Text>
          ),
          points: formatNumber(points * productQuantity),
        }}
      />
    </Text>
  );
};
